import { IPromptProps } from '../type';

/**
 * through "prompt" you can pass only a string, so we turn props object into a json string
 *
 * @param {IPromptProps} [props]
 * @returns JSON string
 */
export const getPromptProps = (props?: IPromptProps): string => {
  return JSON.stringify(props || '');
};
